<template lang="pug">
div
    update-cell-form(v-if="canManageOrderLayout" v-show="hasSelectedGrid")
    action-pages-panel
    action-details-panel
    action-groups-panel
</template>

<script>
import { mapGetters } from 'vuex';
import actionDetailsPanel from './action/action-details';
import actionGroupsPanel from './action/action-groups';
import actionPagesPanel from './action/action-pages';
import updateCellForm from './order-layout-update-cell.vue';
import PermissionMixin from './order-layout-permission';

export default {
    components: {
        actionDetailsPanel,
        actionPagesPanel,
        actionGroupsPanel,
        updateCellForm,
    },

    mixins: [PermissionMixin],

    computed: {
        ...mapGetters('orderLayout', ['hasSelectedGrid']),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/order-layout/order-layout-action-menu.vue